import React, { ForwardedRef, forwardRef } from "react";
import getclassNames from "../../utils/getClassNames";
import './Select.css';
import ReactSelect, { SingleValue } from 'react-select';
import RadioButton from "./RadioButton";

interface OptionType {
    value: string;
    label: string;
}

const getFlattenedOptions = (options: any): any[] => {
    const flattenedOptions = [];
    if (Array.isArray(options)) {
        for (const o of options) {
            const retrievedOptions = getFlattenedOptions(o);
            for (const ro of retrievedOptions) {
                flattenedOptions.push(ro);
            }
        }
    } else if (options.type === 'option') {
        flattenedOptions.push(options);
    }

    return flattenedOptions;
}

export interface SelectProps {
    name?: string;
    id: string;
    onChange?: (value: string) => void;
    value?: string;
    label?: string;
    labelClassName?: string;
    disabled?: boolean;
    selectClassName?: string;
    children: any[] | any;
    required?: boolean;
}

const Select = forwardRef((props: SelectProps, ref?: ForwardedRef<any>) => {
    const handleOnChange = (e: SingleValue<any>) => {
        if (props.onChange) {
            props.onChange(e?.value || '');
        }
    };

    const flattenedOptions = getFlattenedOptions(props.children);

    const options: OptionType[] = flattenedOptions.map((c: any) => {
        return {
            label: c.props.children,
            value: c.props.value?.toString()
        }
    });

    const directions = [];
    if (props.required) {
        directions.push('required');
    }

    directions.push('select one');

    return (<div className="select-container">
        {props.label && <label htmlFor={props.id} className={getclassNames('select-label', props.labelClassName || '')}>{props.label} <span className="show-on-print text-italic">({directions.join(', ')})</span></label>}
        {props.required && <span className="margin-start-1 text-danger hide-on-print">*</span>}
        <div className="show-on-print">
            <RadioButton id={props.id}
                options={options.filter(o => o.value)}
                value={options.find(o => o.value?.toString() === props.value?.toString())?.value || ''} />
        </div>
        <div className="hide-on-print">
            <ReactSelect options={options}
                id={props.id}
                ref={ref}
                name={props.name || props.id}
                isClearable={true}
                styles={{
                    menu: (base) => ({ ...base, zIndex: 30 })
                }}
                value={options.find(o => o.value?.toString() === props.value?.toString()) || ''}
                classNames={{
                    control: (state) => getclassNames('select', props.selectClassName || '', state.isFocused ? 'select-focused' : ''),
                    option: (state) => state.isFocused || state.isSelected ? 'select-option' : ''
                }}
                isSearchable={true}
                escapeClearsValue={true}
                onChange={handleOnChange}
                isDisabled={props.disabled || false} />
        </div>
    </div>);
});

export default Select;